(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(factory());
}(this, (function () { 'use strict';

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var print = require('./print');
var sentenceCase = require('change-case').sentenceCase;

var ParseError = function (_SyntaxError) {
  inherits(ParseError, _SyntaxError);

  function ParseError(message, path) {
    classCallCheck(this, ParseError);

    var node = path.node;
    var start = node.loc.start;
    var lineNumber = start.line;
    var columnNumber = start.column;
    var fileName = '@pushbot-expression';
    var description = message + ' (' + fileName + ':' + lineNumber + ':' + columnNumber + ')';

    var _this = possibleConstructorReturn(this, (ParseError.__proto__ || Object.getPrototypeOf(ParseError)).call(this, description, fileName, lineNumber));

    _this.columnNumber = columnNumber;
    return _this;
  }

  return ParseError;
}(SyntaxError);



var InvalidTypeError = function (_ParseError) {
  inherits(InvalidTypeError, _ParseError);

  function InvalidTypeError(path) {
    classCallCheck(this, InvalidTypeError);
    return possibleConstructorReturn(this, (InvalidTypeError.__proto__ || Object.getPrototypeOf(InvalidTypeError)).call(this, sentenceCase(path.node.type) + 's \'' + print(path.node).code + '\' are not supported', path));
  }

  return InvalidTypeError;
}(ParseError);



module.exports.ParseError = ParseError;
module.exports.InvalidTypeError = InvalidTypeError;

})));
//# sourceMappingURL=error.js.map
